import { Component, Input } from '@angular/core';
import { AppSettings } from '../../../app.settings';

@Component({
  selector: 'app-compared-json-configs',
  templateUrl: './compared-json-configs.component.html',
  styleUrls: ['./compared-json-configs.component.scss'],
})
export class ComparedJsonConfigsComponent {
  @Input() keysExclusiveToCurrentEnv: any[] = [];
  @Input() keysExclusiveToComparedEnv: any[] = [];
  @Input() envToCompare = '';

  env = AppSettings.getCanonicalConfigEnv();
}
